/**
 * Check if value is valid to be filtered
 * @param value
 */
export function isValueFilterValid(value: any): boolean {
  return value !== null && value !== undefined;
}
